import {isAnyPremium} from '@freckle/educator-entities/ts/common/logic/premium-access'
import {PremiumLicensesAttrs} from '@freckle/educator-entities/ts/common/models/premium-licenses'
import {SidebarIdT} from '@freckle/classroom/ts/common/components/sidebar/common/logic'
import {SidebarSection} from '@freckle/classroom/ts/common/components/sidebar/common/section'
import {SidebarLink} from '@freckle/classroom/ts/common/components/sidebar/common/sidebar-link-button/link'
import {Routes} from '@freckle/classroom/ts/common/routers/routes'

export type SectionLinkInfoT = {
  route: string
  tabId: SidebarIdT
}

type Props = {
  premiumLicenses: PremiumLicensesAttrs
}

export function SidebarSectionMain(props: Props) {
  const {premiumLicenses} = props

  return (
    <SidebarSection>
      <>
        <SidebarLink
          // eslint-disable-next-line i18next/no-literal-string
          tabId="dashboard-tab"
          href={Routes.dashboard()}
        />
        <SidebarLink
          // eslint-disable-next-line i18next/no-literal-string
          tabId="activity-feed-tab"
          href={Routes.activityFeed()}
        />
        <SidebarLink
          // eslint-disable-next-line i18next/no-literal-string
          tabId="assignments-tab"
          href={Routes.assignments()}
        />
        <SidebarLink
          // eslint-disable-next-line i18next/no-literal-string
          tabId="common-reports-tab"
          href={Routes.reportsOverview()}
        />
        <SidebarLink
          // eslint-disable-next-line i18next/no-literal-string
          tabId="rosters-tab"
          href={Routes.rostering.rosters()}
        />
        {isAnyPremium(premiumLicenses) ? null : (
          <SidebarLink
            // eslint-disable-next-line i18next/no-literal-string
            tabId="get-premium-tab"
            href={Routes.pricing()}
          />
        )}
      </>
    </SidebarSection>
  )
}
